<template>
    <div class="image-popup" :style="overlayBgStyle">
        <div class="close-button">
            <q-btn icon="close" flat round dense @click="$emit('closeImageAudio')" />
            <ReturnHomeButton @click="$emit('closeAllDialogs')" />
        </div>
        <div class="image-popup-container">
            <div class="image-popup-item" v-for="(resource, index) in resources" :key="index">
                <img v-if="isImage(resource)" class="image" :src="resource.url" :style="rotationStyles[resource.id]" />
                <audio v-if="resource.associatedAudio" controls>
                    <source :src="resource.associatedAudio" type="audio/mp3">
                    Votre navigateur ne supporte pas l'élément audio.
                </audio>
            </div>
        </div>
    </div>
</template>
    
<script setup>
import axios from 'axios';
import { ref, onMounted, defineProps } from 'vue';
import ReturnHomeButton from './ReturnHomeButton.vue';
import { useOverlayBg } from '../composables/useOverlayBg';

const props = defineProps(['blockImageAudioDatas']);
const resources = ref([]);
const rotationStyles = ref({})
const { overlayBgStyle } = useOverlayBg();

const start = async () => {
    await fetchResources();
    await handleRotation();
};

const fetchResources = async () => {
    try {
        if (props.blockImageAudioDatas) {
            // Tableau temporaire pour stocker les ressources avec leur index
            const resourcesTemp = [];
            
            for (let i = 0; i < props.blockImageAudioDatas.associatedResources.length; i++) {
                const blockData = props.blockImageAudioDatas.associatedResources[i];
                const url = `${process.env.VUE_APP_BASEURL}/s3Resource/${blockData.name}`;
                let response = await axios.get(url);
                var resourceUrl = response.data;
                const newResource = { 
                    url: resourceUrl, 
                    title: blockData.title, 
                    id: blockData.resource_id,
                    index: blockData.index !== undefined ? blockData.index : i
                };

                // Extrait le nom de l'audio entre les crochets
                const audioTitle = newResource.title.match(/\[(.*?)\]/)?.[1];
                if (audioTitle) {
                    // Trouve la ressource audio correspondante
                    const audioResource = props.blockImageAudioDatas.associatedResources.find(r => r.title === audioTitle);
                    if (audioResource) {
                        const url2 = `${process.env.VUE_APP_BASEURL}/s3Resource/${audioResource.name}`;
                        let response2 = await axios.get(url2);
                        var audioUrl = response2.data;
                        newResource["associatedAudio"] = audioUrl;
                    }
                }
                resourcesTemp.push(newResource);
            }
            
            // Trier les ressources par index
            resourcesTemp.sort((a, b) => a.index - b.index);
            
            // Assigner les ressources triées
            resources.value = resourcesTemp;
        }
    } catch (error) {
        console.error(error);
    }
};


const handleRotation = async () => {
    try {
        resources.value.map(async resource => {
            let url = `${process.env.VUE_APP_BASEURL}/position/${resource.id}`;
            let response = await axios.get(url);
            var angle = 0;
            if (response.data[0]) {
                angle = response.data[0].angle;
            }
            rotationStyles.value[resource.id] = {
                transform: `rotate(${angle}deg)`
            }
        })


    } catch (error) {
        console.log(error);
    }
}



const isImage = (resource) => {
    // Teste si le titre contient un nom entre crochets
    const hasBracketedText = /\[(.*?)\]/.test(resource.title);
    if (hasBracketedText)
        return true;
    else
        return false;
};

onMounted(start);


</script>
    
<style scoped>
.image-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(217, 217, 217, 0.95);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.image-popup-container {
    width: 70%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: scroll;
    margin-top: 1%;

}

.image-popup-item {
    margin: 10px 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    /* Si vous avez des éléments audio en plus des images, utiliser flex-direction: column pour un meilleur agencement */
    justify-content: center;
    align-items: center;
}

.image {
    width: auto;
    height: 80%;
    object-fit: contain;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border: 2px solid #f0f0f0;
}


.image-popup-item audio {
    width: 50%;
}
</style>
  